<!-- <ng-template #windowODTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template> -->
<!-- @if(editODUsersWinOpen){
<div class="k-overlay"></div>
} -->
<!-- <ng-container #container></ng-container> -->

<!-- <div class="container" my-5 #appendWinTo> -->

<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
  [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
  style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize" [pageable]="true">

  <ng-template kendoGridToolbarTemplate position="top">
    <button (click)="onAddClick()" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add Discipline </button>
  </ng-template>

  <kendo-grid-column title="No. of Users" [width]="120">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onUserClick(dataItem)" kendoButton class="btn btn-stn-grid" [hidden]="!isSuperUser">
        {{dataItem.no_users}}
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="discipline_name" title="Discipline Name" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column title="Delete" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="trash"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>


  <ng-template kendoPagerTemplate>
    <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
  </ng-template>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>

<!-- </div> -->

<!-- <div kendoWindowContainer></div> -->
<!-- <div wallyWindowContainer></div> -->

<!-- @if(editODUsersWinOpen) {
<div class="k-overlay"></div>

<kendo-window (close)="close($event)" [draggable]="isDraggable" [width]="1000" [(top)]="windowTop"
  [(left)]="windowLeft">
  <kendo-window-titlebar>
    <span class="k-window-title">MANAGE ORGANISATION DISCIPLINES</span>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <casi-organisation-discipline-users-win (onCancel)="close($event)"
    [organisationDiscipline]="currentSelection"></casi-organisation-discipline-users-win>
</kendo-window>

} -->
